import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TrashOutlineIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      id="Icon_Button_-_Delete"
      data-name="Icon Button - Delete"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_1954"
        data-name="Rectangle 1954"
        width={width || "32"}
        height={height || "32"}
        rx="5"
        fill="#fff"
      />
      <path
        id="Path_10412"
        data-name="Path 10412"
        d="M8.375-1h.75A.375.375,0,0,0,9.5-1.375v-6.75A.375.375,0,0,0,9.125-8.5h-.75A.375.375,0,0,0,8-8.125v6.75A.375.375,0,0,0,8.375-1ZM13.5-11.5H10.925L9.862-13.272A1.663,1.663,0,0,0,8.576-14H5.425a1.663,1.663,0,0,0-1.286.728L3.075-11.5H.5A.5.5,0,0,0,0-11v.5a.5.5,0,0,0,.5.5H1V.5A1.5,1.5,0,0,0,2.5,2h9A1.5,1.5,0,0,0,13,.5V-10h.5a.5.5,0,0,0,.5-.5V-11A.5.5,0,0,0,13.5-11.5Zm-8.13-.909a.208.208,0,0,1,.161-.091H8.469a.208.208,0,0,1,.161.091l.546.909H4.825ZM11.5.5h-9V-10h9ZM4.875-1h.75A.375.375,0,0,0,6-1.375v-6.75A.375.375,0,0,0,5.625-8.5h-.75a.375.375,0,0,0-.375.375v6.75A.375.375,0,0,0,4.875-1Z"
        transform="translate(9 22)"
        fill="#979797"
      />
    </svg>
  );
}
